
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12.626","height":"8.962","viewBox":"0 0 12.626 8.962"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.481 8.962a.828.828 0 01-.587-.243L.243 5.068a.83.83 0 011.174-1.174l3.065 3.065L11.209.243a.83.83 0 111.173 1.175L5.068 8.72a.828.828 0 01-.587.242z","fill":"#fff"}})])
          )
        }
      }
    